import type { ReactNode } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";

// Every AppDialog is now a full dedicated page (see AppDialog.tsx - always
// fullScreen, no floating modal card anymore), so leaving it reads as page
// navigation ("go back"), not modal dismissal ("close") - a back arrow at
// the top-left, matching every mobile-app/page-navigation convention,
// instead of the X-at-top-right every one of these dialogs used to have.
// Centralized here (rather than each dialog copy-pasting its own header)
// so every page's header stays visually and behaviorally consistent.
export function AppDialogHeader({
  icon,
  title,
  onBack,
  disabled,
}: {
  icon?: string;
  title: ReactNode;
  onBack: () => void;
  disabled?: boolean;
}) {
  return (
    <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pb: 0 }}>
      <IconButton
        aria-label="Back"
        onClick={onBack}
        size="small"
        disabled={disabled}
        sx={{ ml: -1, flexShrink: 0 }}
      >
        <i className="bi bi-arrow-left" aria-hidden="true" />
      </IconButton>
      <Box
        component="span"
        sx={{
          display: "flex",
          alignItems: "center",
          fontSize: "1.1rem",
          fontWeight: 600,
          minWidth: 0,
        }}
      >
        {icon && (
          <i
            className={`bi ${icon} me-2 text-pink`}
            aria-hidden="true"
            style={{ marginRight: 8, flexShrink: 0 }}
          />
        )}
        {title}
      </Box>
    </DialogTitle>
  );
}
